import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { sortByName, teamMemberMapper } from '~/utils/clientAllocation';
import { IActTeamMemberActions, IThunkGetAllocationTeamMembers } from '../types';

const onGetAllocationTeamMembers: IThunkGetAllocationTeamMembers = thunk(
  async ({ setAllocationTeamMembers }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, actTeamId } = payload;

    const data = await api.actTeamMember
      .getActTeamMemberList(clinicId, actTeamId)
      .then(r => r.data);

    setAllocationTeamMembers((data || []).sort(sortByName).map(teamMemberMapper));
  },
);

export default onGetAllocationTeamMembers;
